export const REPs = [
  {
    providerId: "196",
    providerName: "Constellation",
    host: true,
  },
  {
    providerId: "163",
    providerName: "Direct Energy",
  },
  {
    providerId: "176",
    providerName: "TXU Energy",
  },
  {
    providerId: "159",
    providerName: "Reliant",
  },
];

export const ThreeReps = [163, 176, 159];

export const Tier = [10, 166, 290, 167, 208, 165]; // Green Mountain Energy, Frontier Utilities, Spark Energy, Cirro Energy, 3 reps
export const IS_DEV = false;

export const REFERER_URL = IS_DEV
  ? "https://d3ea8w7sm64l25.cloudfront.net/"
  : "https://www.compareconstellation.com/";

export const API_KEY = IS_DEV
  ? "eea1bbda1f8835b27dd821a65c658ddb"
  : "32a72062e2e878d53d97c829a09335b8";
export const ACC_KEY = API_KEY;
export const API_URL =
  "https://bb0xg7o51l.execute-api.us-east-2.amazonaws.com/v1";
export const POWERLEGO_API_URL = IS_DEV
  ? "https://dev.powerlego.com/ApiGateway"
  : "https://www.powerlego.com/ApiGateway";
// Revert back dev to https://secure2.paymentus.com/xotp/pm/ceb?authToken=
export const PAYMENT_IFRAME_URL = IS_DEV
  ? "https://secure2.paymentus.com/xotp/pm/ceb?iframe=true&authToken="
  : "https://ipn2.paymentus.com/xotp/pm/ceb?iframe=true&authToken=";

export const PAYMENT_TOKEN_URL = IS_DEV
 ? "https://8vychihcu9.execute-api.us-east-2.amazonaws.com/dev/paymentus/generate-token"
 : "https://hks422p6t6.execute-api.us-east-2.amazonaws.com/v1/paymentus/generate-token"

export const PROVIDER_ID = "196";
export const PROVIDER_NAME = "Constellation";

export const PROMO_CODE = IS_DEV ? "EIQPPC" : "EIQPPC";

export const iCheckConfig = {
  ccUrl: "https://iframe.icheckgateway.com/iFrameCC.aspx",
  baUrl: "https://iframe.icheckgateway.com/iFrameBA.aspx",
  appId: IS_DEV ? "123456" : "123456",
  appSecret: IS_DEV ? "123456" : "123456",
  // appSiteId: 'NBPP',
  styles:
    'payment{background:white;border-color:rgb(221,221,221);}input[type="submit"],input[type="reset"]{background:rgb(255,91,106);border-radius:30px;border:0 none;}',
};

export const dunsUtilityList = [
  { value: "007923311", label: "AEP North", id: "4", code: "AEPWTU" },
  { value: "007924772", label: "AEP Central", id: "6", code: "AEPCPL" },
  {
    value: "007929441",
    label: "Texas New Mexico Power (TNMP)",
    id: "5",
    code: "TNMP",
  },
  {
    value: "1039940674000",
    label: "Oncor Electric Delivery",
    id: "2",
    code: "Oncor",
  },
  { value: "957877905", label: "CenterPoint Energy", id: "1", code: "CPE" },
  // { value: '0088288574800', label: 'Nueces Coop' },
  // { value: '827438383', label: 'Entergy Gulf States Inc' },
];

export const CONSTELLATION_UTIL_MAPPING = {
  CPE: "CNP",
  ONCOR: "ONCOR",
  AEPWTU: "AEP-WTU",
  TNMP: "TNMP",
  AEPC: "AEP-CPL",
  LPL: "LPL",
}; 
